import React, { Component } from 'react';
import Button from '../../components/Button';
import Benefits from '../../components/Benefits';
import Heading from '../../components/Heading';
import WorkersList from '../../components/WorkersList';
import VacanciesList from '../../components/VacanciesList';
import CompaniesList from '../../components/CompaniesList';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { HOST } from '../../constants/Fetch';
import Preloader from '../../components/Preloader';
import ErrorMessage from '../../components/ErrorMessage';
import Slider from "react-slick";
import '../../assets/styles/slider.css';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadVacancies } from '../../actions/VacanciesActions';
import { loadCompanies } from '../../actions/CompaniesActions';
import { loadCompany } from '../../actions/CompanyActions';
import { setFilterData } from "../../actions/FiltersActions";

class PageCompany extends Component {
  static requestData(store, match) {
    return requestAll([loadVacancies, () => loadCompany(match.params.company), loadCompanies], store);
  }

  componentDidMount() {
    this.props.actions.loadVacancies();
    this.props.actions.loadCompanies();
    this.props.actions.loadCompany(this.props.match.params.company);
  }

  render() {
    const companyVacancies = this.props.vacancies.filter(vacancy => vacancy.company.id === this.props.company.id && vacancy.is_popular);
    const sliderSettings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    const {
      advantages = [],
      advantage_header: advantageHeader,
    } = this.props.company

    if (this.props.hasErrored) {
      return <ErrorMessage/>;
    }

    if (this.props.isLoading) {
       return <Preloader/>;
    }

    return (
      <div>
        <Heading name={this.props.company.name} background={HOST + this.props.company.background_image} />
        {
          this.props.company.content &&
          <div className="container container--indentVertical">
            <div className="row">
              <div className="col col--9">
                <h2 className="text text--h2">О компании</h2>
                <div className="text">{this.props.company.content}</div>
              </div>
            </div>
          </div>
        }
        <div className="container container--noPaddinngVertTablet">
          <Benefits
            title={advantageHeader}
            advantages={advantages}
          />
        </div>
        <div className="container container--indentVertical">
          <h2 className="text text--h2">Истории успеха</h2>
          <WorkersList cols={4} />
        </div>
        <div className="container container--indentVertical">
          {
            companyVacancies.length > 0 &&
            <React.Fragment>
              <h2 className="text text--h2">Популярные вакансии</h2>
              <VacanciesList compact={true} cols={6} data={companyVacancies} {...this.props} />
            </React.Fragment>
          }
          <Button onClick={() => this.props.handleClick(this.props.company.id, this.props.company.name)} link="vacancies" text={`Показать все вакансии «${this.props.company.name}»`} />
        </div>
        {
          (this.props.company.gallery_images && this.props.company.gallery_images.length > 0) &&
          <div className="container container--indentVertical">
              <Slider {...sliderSettings}>
                {
                  this.props.company.gallery_images
                  .sort(function (a, b) {
                    if (a.order > b.order) {
                      return a - b;
                    }
                  })
                  .map((photo, index) => (
                    <img src={HOST + photo.image} alt="" key={`sliderGallery-${index}`} />
                  ))
                }
              </Slider>
          </div>
        }
        <div className="container container--indentVertical">
          <h2 className="text text--h2">ЭР-Телеком Холдинг</h2>
          <CompaniesList
            data={this.props.companies}
            {...this.props}
            modifier="companiesList--negativeBottom"
            companiesForShow={['ЭР-Телеком', 'Дом.ru', 'Дом.ru Бизнес']}
          />
        </div>
      </div>
    );
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.company !== this.props.match.params.company) {
      this.props.actions.loadCompany(nextProps.match.params.company);
    }
  }
}

const mapStateToProps = (state) => {
  return {
      companies: state.companies.list,
      company: state.company.item,
      vacancies: state.vacancies.list,
      hasErrored: state.company.hasErrored,
      isLoading: state.company.isLoading,
      filter: state.filter
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadVacancies, loadCompanies, loadCompany }, dispatch),
    handleClick: (val, label) => {
      dispatch(setFilterData(val, label, 'company'))
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageCompany));



// WEBPACK FOOTER //
// ./src/pages/PageCompany/index.js